import { FC } from "react";
import { useTranslation } from "react-i18next";

import { SVG_MUI } from "@ryde/assets";
import { FramerTooltip } from "@ryde/controls";
import { TOOLTIP_DELAY_BUTTONS, usePrefixedRouting } from "@ryde/shared";
import { deepPurpleMui } from "@ryde/theme";

import { ReportDashboardButtonStyled } from "./reports.styled";

export const ReportNavigationDashboardButton: FC = () => {
  const { t } = useTranslation();
  const { addPrefix } = usePrefixedRouting();
  const color = deepPurpleMui.A700;
  return (
    <FramerTooltip
      content={t("ui.NAVIGATE_TO_DASHBOARD")}
      mouseEnterDelay={TOOLTIP_DELAY_BUTTONS}
    >
      <ReportDashboardButtonStyled to={addPrefix("/")}>
        <SVG_MUI.ChartUiSVG
          fill={color}
          className="NavigateToDashboardButtonSVG"
        />
        <label style={{ color }}>{t("ui.NAVIGATE_TO_DASHBOARD")}</label>
      </ReportDashboardButtonStyled>
    </FramerTooltip>
  );
};
